const NAME_SPACE = 'NavigationDesktop';

export { NAME_SPACE };
